const fontFamilyObj = {
	"titleFamily": "Montserrat",
	"bodyFamily": "Open Sans",
	"timerFamily": "Acherus Militant",
	"numberFamily": "Acherus Militant",
	"bodyCondensedFamily": "Open Sans Condensed"
};


// AITC
const aitcPalette = {
	"primaryColor": "#020940",        
	"primaryVariantColor": "#572676", // existing color
	"secondaryColor": "#4DF4FE",      
	"secondaryColorLite": "#9281FA",  // existing color
	"secondaryVariantColor": "#FF1E50",  // existing color
	// existing	colors
	"grayColor1": "#14324B",
	"grayColor2": "#7E8E9C",
	"grayColor3": "#A6B1BB",
	"grayColor4": "#C2CAD0",
	"grayColor5": "#D2D8DD",
	"grayColor6": "#E3E6E9",
	"grayColor7": "#F1F3F4",
	"grayColor8": "#F8F9F9",
	"black": "#000000",
	"white": "#FFFFFF",
	"blue": "#42BAFF",
	"yellow": "#FDAD28",
	"red": "#FD5382",
	"green": "#1BE1D4",
};

const storylineThemes = {
	1: {
		globalProfiles: {
			palette: aitcPalette
		}
	}
};

// Default theme (Storyline 1)
const globalProfiles = {
	"palette": aitcPalette
};

const entityProfiles = []

const skins = {
	fontFamily: fontFamilyObj,
	globalProfiles: globalProfiles,
	entityProfiles: entityProfiles,
	storylineThemes: storylineThemes
};

export default skins;
